import { z } from 'zod';
export const SKILL_CATALOG = [
    // Q7 — footcare is a skill modifier on RPN/RN profiles, not a role.
    { code: 'FOOTCARE', label: 'Footcare', eligibleRoles: ['RPN', 'RN'] },
    // Phase 17 (change-list) — palliative-care experience, offered to the four
    // care-professional roles (not DSW / Cook).
    {
        code: 'PALLIATIVE_CARE',
        label: 'Palliative care experience',
        eligibleRoles: ['RN', 'RPN', 'PSW', 'COMPANION'],
    },
];
const SKILL_BY_CODE = new Map(SKILL_CATALOG.map((s) => [s.code, s]));
/** The skills a caregiver with these roles is allowed to declare (the checkbox
 *  set the portal renders). A skill qualifies if any of its eligible roles is
 *  held. */
export function skillsForRoles(roleCodes) {
    const held = new Set(roleCodes);
    return SKILL_CATALOG.filter((s) => s.eligibleRoles.some((r) => held.has(r)));
}
/** True iff `skillCode` exists AND at least one of the caregiver's roles makes
 *  it eligible. Guards the backend set-skills write. */
export function isSkillEligibleForRoles(skillCode, roleCodes) {
    const def = SKILL_BY_CODE.get(skillCode);
    if (!def)
        return false;
    const held = new Set(roleCodes);
    return def.eligibleRoles.some((r) => held.has(r));
}
export function skillLabel(code) {
    return SKILL_BY_CODE.get(code)?.label ?? code;
}
/** PUT /api/v1/me/caregiver/skills — replace the caregiver's declared skill set.
 *  Full-set semantics (idempotent): send every skill that should be present.
 *  Codes are validated against the catalog + the caregiver's roles server-side. */
export const CaregiverSetSkillsRequestSchema = z.object({
    skillCodes: z.array(z.string().min(1).max(40)).max(20),
});
//# sourceMappingURL=skill-catalog.js.map